<script>
  import Header from "lib/components/Header.svelte";
  import PercentageBar from "../../../../lib/components/PercentageBar.svelte";
  import { recordingStore } from "@stores/recordingStore.js";
  import {
    DataTableSkeleton,
    InlineLoading,
    Loading,
    Modal as DangerModal,
  } from "carbon-components-svelte";
  import {
    Tooltip,
    SectionWrapper,
    InfoBlock,
    Select,
    Button,
    Tag,
  } from "paxray-components-svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import Dialog from "../../../../lib/components/Dialog.svelte";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
  import { onDestroy, onMount, tick } from "svelte";
  import TaskExplorerPreview from "./TaskExplorerPreview.svelte";
  import { fly } from "svelte/transition";
  import Elipse from "../../../../lib/icons/Elipse.svelte";
  import LFilters from "../components/LFilters.svelte";
  import SideKPI from "@components/sideKPI.svelte";
  import DataTableBlack from "@components/DataTableBlack.svelte";
  import SpotlightGuide from "@components/common/SpotlightGuide.svelte";
  import { registerViewTour } from "lib/stores/viewTourStore.js";
  import {
    EDIT_ICON,
    ERASE_ICON,
    PREVIEW_ICON,
    TRASH_ICON,
  } from "@utils/icons.js";

  let urlParams = new URLSearchParams(window.location.search);
  let idproject = urlParams.get("idproject");

  let totalTaskRegistered = 750;
  let totalTask = 1000;
  let loadingOverview = false;
  let assigningRegistrations = false;
  let assignmentMessage = "";
  let assignmentFailed = false;
  let assignmentModalOpen = false;
  let assignmentComplete = false;
  let assignmentProgress = null;
  let assignmentTimer;
  let assignmentDisposed = false;

  onDestroy(() => {
    assignmentDisposed = true;
    clearTimeout(assignmentTimer);
  });

  function openAssignmentModal() {
    assignmentModalOpen = true;
  }

  function closeAssignmentModal() {
    assignmentModalOpen = false;
    if (!assigningRegistrations) {
      assignmentFailed = false;
      assignmentComplete = false;
      assignmentMessage = "";
      assignmentProgress = null;
    }
  }

  async function updateAssignmentStatus(job, startedAt) {
    if (assignmentDisposed) return;
    if (
      job.project_id !== idproject ||
      job.stage !== "taxonomy_assignment" ||
      job.started_at !== startedAt
    ) {
      throw new Error(
        "The assignment status is no longer available. Reload the overview to check the result.",
      );
    }
    if (job.status === "failed") {
      throw new Error(job.error || "Registration assignment failed.");
    }
    if (job.status === "completed") {
      assignmentMessage = "Updating the registration overview…";
      await recordingStore.initialize(idproject, { force: true });
      await recordingStore.getRecordings(idproject);
      if (assignmentDisposed) return;
      setRowsOverview();
      const result = job.results?.taxonomy_assignment;
      assignmentMessage = result
        ? `${result.newly_assigned ?? 0} newly assigned · ${result.unassigned ?? 0} unmatched`
        : "Assignments updated.";
      assigningRegistrations = false;
      assignmentComplete = true;
      return;
    }
    if (job.status !== "running") {
      throw new Error(
        "The assignment status is unavailable. Reload the overview to check the result.",
      );
    }
    assignmentMessage = "Assigning registrations…";
    assignmentProgress =
      job.total_items > 0
        ? { done: job.completed_items ?? 0, total: job.total_items }
        : null;
    assignmentTimer = setTimeout(async () => {
      try {
        const response = await fetchWithSession(
          "/api/damprojects/admin/preprocessing",
        );
        if (!response.ok)
          throw new Error(
            "Could not load assignment status. The job may still be running.",
          );
        await updateAssignmentStatus(await response.json(), startedAt);
      } catch (assignmentError) {
        if (assignmentDisposed) return;
        assignmentFailed = true;
        assignmentMessage = assignmentError.message;
        assigningRegistrations = false;
      }
    }, 3000);
  }

  async function assignRegistrations() {
    if (assigningRegistrations || !idproject) return;
    assigningRegistrations = true;
    assignmentFailed = false;
    assignmentComplete = false;
    assignmentProgress = null;
    assignmentMessage = "Starting assignment…";
    try {
      const response = await fetchWithSession(
        "/api/damprojects/admin/preprocessing",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            project_id: idproject,
            stage: "taxonomy_assignment",
            clean: false,
          }),
        },
      );
      const job = await response.json();
      if (!response.ok)
        throw new Error(
          job.message || "Registration assignment could not be started.",
        );
      await updateAssignmentStatus(job, job.started_at);
    } catch (assignmentError) {
      if (assignmentDisposed) return;
      assignmentFailed = true;
      assignmentMessage = assignmentError.message;
      assigningRegistrations = false;
    }
  }
  let selectedProcess = "";
  let selectedSubprocess = "";
  let selectedTeam = "";
  let selectedTask = "";
  let selectedSubtask = "";
  let selectedAssignedOption = "";
  let openEditModal = false;
  let openDangerModal = false;
  let modalTypeDelete = false;
  let deletingRecording = false;
  let openPreview = false;
  let currentSubtask = "";
  let selectedRow = null;
  let fullscreen = false;
  let editRow = {
    subtaskid: "",
    taskid: "",
    subprocessid: "",
    processid: "",
    recordings: "",
  };
  let listOfTeams = [];
  let listOfProcesses = [];
  let listOfSubprocesses = [];
  let listOfTasks = [];
  let listOfSubTasks = [];
  let listOfRecordings = [];

  $: listOfProcesses = $recordingStore.processes || [];
  $: listOfSubprocesses = $recordingStore.listOfSubprocesses || [];
  $: listOfTasks = $recordingStore.listOfTasks || [];
  $: listOfSubTasks = $recordingStore.listOfSubtasks || [];
  $: listOfRecordings = ($recordingStore.listOfRecordings || []).map(
    (recording) => ({
      ...recording,
      recorderid: recording.recorderid ?? recording.recording_id,
      teamid: recording.teamid ?? recording.team_id,
      starttimeutc: recording.starttimeutc ?? recording.start_time,
      endtimeutc: recording.endtimeutc ?? recording.end_time,
    }),
  );
  $: listOfTeams = $recordingStore.listOfTeams || [];

  $: if (listOfRecordings.length > 0 && listOfSubTasks.length >= 0) {
    setRowsOverview();
  }
  let previewTaskid = null;
  let lastDate;
  let registrationsCount = 0;
  let searchTerm = "";
  let expandedRowIds = [];
  let graphActivities;
  let lFiltersRef;

  let taskExplorerPreviewController;
  let overviewTourMounted = false;
  let unregisterOverviewTour;
  let showOverviewGuide = false;
  let overviewGuideStep = 0;
  let overviewGuideSteps = [];
  let overviewGuideActive = false;
  let expandedRowsBeforeGuide = [];

  $: if (overviewGuideActive && !showOverviewGuide) {
    expandedRowIds = expandedRowsBeforeGuide;
    overviewGuideActive = false;
  }

  onMount(() => {
    overviewTourMounted = true;
    return () => {
      overviewTourMounted = false;
      unregisterOverviewTour?.();
    };
  });

  $: if (overviewTourMounted && !loadingOverview) {
    if (!unregisterOverviewTour)
      unregisterOverviewTour = registerViewTour(startOverviewGuide);
  } else {
    unregisterOverviewTour?.();
    unregisterOverviewTour = null;
    showOverviewGuide = false;
  }

  async function startOverviewGuide() {
    if (
      overviewGuideActive ||
      assignmentModalOpen ||
      openEditModal ||
      openDangerModal ||
      openPreview
    )
      return;
    expandedRowsBeforeGuide = [...expandedRowIds];
    const visibleGroupId = [
      ...document.querySelectorAll(
        '[data-guide="registration-overview-table"] tr[data-row]',
      ),
    ]
      .find((row) =>
        row.querySelector('button[aria-label="Expand current row"]'),
      )
      ?.getAttribute("data-row");
    const firstGroup = filteredRowsOverview.find(
      (row) => String(row.id) === visibleGroupId,
    );
    const hasVisibleActions = [
      ...document.querySelectorAll(
        '[data-guide="registration-overview-table"] .actions-cell',
      ),
    ].some(
      (element) =>
        element.getBoundingClientRect().width > 0 &&
        element.getBoundingClientRect().height > 0,
    );
    if (firstGroup && !hasVisibleActions) {
      expandedRowIds = [...new Set([...expandedRowIds, firstGroup.id])];
      await tick();
    }
    if (!overviewTourMounted) return;
    overviewGuideSteps = [
      {
        target: '[data-guide="registration-overview-kpis"]',
        title: "Review your registrations",
        text: "This overview shows the tasks registered by your teams and their assigned process details. “Registrations” shows the total count, and “Last Registration” shows the latest registration date.",
      },
      {
        target: ".overview_canvas",
        highlightSelector:
          '[data-guide="registration-overview-filters"], .process-registration-overview-table .bx--search',
        title: "Find the entries you need",
        text: "Filter by team, process, subprocess, task or subtask. Choose “Show Not Assigned” to find registrations that still need a task assignment. Use the table search to find specific entries.",
      },
      ...(filteredRowsOverview.length > 0
        ? [
            {
              target: '[data-guide="registration-overview-table"] table',
              title: "Explore grouped registrations",
              text: "Review the registration name, team and assigned process levels. “Count” shows how many registrations a row represents. Expand grouped rows to inspect the individual registrations.",
            },
            {
              target:
                '[data-guide="registration-overview-table"] tbody .duration_green, [data-guide="registration-overview-table"] tbody .duration_yellow, [data-guide="registration-overview-table"] tbody .duration_red',
              title: "Check possible outliers",
              text: "The Status colour highlights possible outliers. Green means no indicators were found, yellow means one indicator, and red highlights multiple indicators or an empty registration. Use these indicators to decide which registrations need closer review.",
            },
            {
              target:
                '[data-guide="registration-overview-table"] button[aria-label="Preview registration"]',
              title: "Preview a registration",
              text: "Click “Preview registration” to inspect the registered workflow. Preview requires a task assignment. Review anonymization before inspecting the underlying data.",
            },
          ]
        : []),
      {
        target: '[data-guide="assign-overview-registrations"]',
        title: "Assign registrations to the framework",
        text: "Click “Assign registrations” to match unassigned entries using participant selections or matching names. Existing assignments are preserved. Use “Edit registration” to choose or correct the process, subprocess, task and subtask manually.",
      },
      ...(filteredRowsOverview.length > 0
        ? [
            {
              target:
                '[data-guide="registration-overview-table"] .actions-cell',
              highlightSelector:
                'button[aria-label="Clear registration assignment"], button[aria-label="Delete registration"]',
              title: "Clear an assignment or remove a registration",
              text: "“Clear registration assignment” removes the link to its task while keeping the registration. “Delete registration” removes the registration itself. Check the selected entry carefully before confirming either action.",
            },
          ]
        : []),
    ]
      .map((guideStep) => {
        const element = [...document.querySelectorAll(guideStep.target)].find(
          (candidate) =>
            getComputedStyle(candidate).visibility === "visible" &&
            candidate.getBoundingClientRect().width > 0 &&
            candidate.getBoundingClientRect().height > 0,
        );
        return element ? { ...guideStep, target: element } : null;
      })
      .filter(Boolean);
    overviewGuideStep = 0;
    showOverviewGuide = overviewGuideSteps.length > 0;
    overviewGuideActive = true;
  }

  let headersOverview = [
    { key: "count", value: "Count", width: "4%" },
    { key: "process", value: "Process (L1)", width: "12%" },
    { key: "subprocess", value: "Subprocess (L2)", width: "13%" },
    { key: "task", value: "Task (L3)", width: "15%" },
    { key: "subtask", value: "Subtask (L4)", width: "13%" },
    { key: "recordingName", value: "Registration Name", width: "15%" },
    { key: "team", value: "Team", width: "8%" },
    { key: "reasons", value: "Status", width: "6%" },
    // { key: "status", value: "Status" }, // COMMENTED OUT TEMPORARILY
    { key: "actions", value: "Actions", width: "14%", sort: false },
  ];

  // /getRecordings
  let rowsOverview = [];

  let selectAssignedOptions = [
    { key: "assigned", value: "Show Assigned" },
    { key: "not_assigned", value: "Show Not Assigned" },
  ];

  let filteredRowsOverview = [];

  // MOCKED ROW TO TEST PREVIEW
  // let filteredRowsOverviewMocked = [
  //   {
  //     id: "1",
  //     process: "1 - Order 2 Cash",
  //     subprocess: "1.1 - Process New Order",
  //     task: "1.1.2 - Create New Sales Order",
  //     team: "Sales",
  //     recordings: "world TEST",
  //     recordingName: "",
  //     subtask: "Subtask A",
  //     numberOfRecordings: 3,
  //     targetValue: 3,
  //     taskid: "7abcbe25-1031-4ff8-9bac-1f1bd4e24b4d",
  //   },
  // ];

  let selectedOverviewIds = [];
  let paginationOverview = {
    page: 1,
    pageSize: 10,
  };

  let filteredRowIds = [];

  let subprocessDatalist = [];
  let subtaskDatalist = [];

  function formatOverviewDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  }

  $: setRows(
    selectedProcess,
    selectedSubprocess,
    selectedTeam,
    selectedTask,
    selectedSubtask,
    selectedAssignedOption,
    searchTerm,
  );

  $: subprocessDatalist = getSubprocessDatalist(editRow.processid);
  $: taskDatalist = getTaskDatalist(editRow.subprocessid);
  $: subtaskDatalist = getSubtaskDatalist(editRow.taskid);
  $: processEditItems = listOfProcesses
    .map((process) => ({ value: process.name, text: process.name }))
    .sort((a, b) => a.text.localeCompare(b.text));
  $: subprocessEditItems = subprocessDatalist
    .map((subprocess) => ({ value: subprocess.name, text: subprocess.name }))
    .sort((a, b) => a.text.localeCompare(b.text));
  $: taskEditItems = taskDatalist
    .map((task) => ({ value: task.name, text: task.name }))
    .sort((a, b) => a.text.localeCompare(b.text));
  $: subtaskEditItems = subtaskDatalist
    .map((subtask) => ({ value: subtask.name, text: subtask.name }))
    .sort((a, b) => a.text.localeCompare(b.text));
  $: registrationsCount = new Set(
    (listOfRecordings || [])
      .filter((recording) => !recording?.deleted && recording?.recorderid)
      .map((recording) => recording.recorderid),
  ).size;
  $: lastRegistrationDate = lastDate ? formatOverviewDate(lastDate) : "-";

  function setRowsOverview() {
    let rows = [];
    lastDate = undefined;
    const recordingsById = new Map();

    (listOfRecordings || []).forEach((recording) => {
      if (!recording?.recorderid || recording.deleted) return;
      recordingsById.set(recording.recorderid, recording);
    });
    const uniqueRecordings = [...recordingsById.values()];
    // COMMENTED OUT TEMPORARILY
    // const assignedRecordingIds = new Set();
    // listOfTasks.forEach((task) => {
    //   let subprocess = listOfSubprocesses.find(
    //     (sp) => sp.id === task.subprocess_id
    //   );
    //   let process = listOfProcesses.find(
    //     (proc) => proc.id === subprocess.process_id
    //   );
    //   const recordingsArr = (task.recordings || []).map((r) => {
    //     assignedRecordingIds.add(r.recording_id);
    //     const matched = listOfRecordings.find(
    //       (rec) => rec.recorderid === r.recording_id
    //     );
    //     return { recording_id: r.recording_id, name: matched?.name || null };
    //   });

    //   // console.log({ recording });
    //   rows.push({
    //     id: task.id,
    //     process: process ? process.name : "",
    //     subprocess: subprocess ? subprocess.name : "",
    //     task: task.name,
    //     team: task.team || "",
    //     numberOfRecordings: recordingsArr.length,
    //     targetValue: task.targetValue || 0,
    //     recordings: recordingsArr,
    //   });
    // });
    uniqueRecordings.forEach((recording) => {
      // COMMENTED OUT TEMPORARILY
      // const isAlreadyAssigned = assignedRecordingIds.has(recording.recorderid);
      // if (!isAlreadyAssigned) {
      //   rows.push({
      //     id: recording.recorderid,
      //     process: "",
      //     subprocess: "",
      //     task: "",
      //     team: recording.team || "",
      //     numberOfRecordings: recording.numberOfRecordings || 0,
      //     targetValue: 0,
      //     recordings: [
      //       {
      //         recording_id: recording.recorderid,
      //         name: recording.name || null,
      //       },
      //     ],
      //   });
      // }

      const recordingDate = new Date(recording.endtimeutc);
      if (!Number.isNaN(recordingDate.getTime())) {
        if (!lastDate || lastDate < recordingDate) lastDate = recordingDate;
      }

      const subtask = listOfSubTasks.find((t) =>
        t.recordings?.some((r) => r.recording_id === recording.recorderid),
      );

      let task = null;
      let subprocess = null;
      let process = null;

      if (subtask) {
        task = listOfTasks.find((t) => t.id === subtask.task_id);
        if (task) {
          subprocess = listOfSubprocesses.find(
            (sp) => sp.id === task.subprocess_id,
          );
          if (subprocess) {
            process = listOfProcesses.find(
              (proc) => proc.id === subprocess.process_id,
            );
          }
        }
      }

      let sameData = rows.find(
        (row) =>
          process?.id &&
          row.processid === process?.id &&
          subprocess?.id &&
          row.subprocessid === subprocess?.id &&
          task?.id &&
          row.taskid === task?.id &&
          subtask?.id &&
          row.subtaskid === subtask?.id,
      );

      if (sameData) {
        sameData.groupedData.push({
          recording_id: recording.recorderid,
          recordingName: recording.name || "",
          team: recording.team || "",
          reasons: recording.reasons || [],
          teamid: recording.teamid || "",
          numberOfRecordings: recording.numberOfRecordings || 0,
          targetValue: 0,
          recordings: [
            {
              recording_id: recording.recorderid,
              name: recording.name || null,
              reasons: recording.reasons || [],
            },
          ],
        });

        sameData.count++;
      } else
        rows.push({
          id: recording.recorderid,
          process: process ? process.name : "",
          processid: process ? process.id : null,
          subprocess: subprocess ? subprocess.name : "",
          subprocessid: subprocess ? subprocess.id : null,
          task: task ? task.name : "",
          taskid: task ? task.id : null,
          subtask: subtask ? subtask.name : "",
          subtaskid: subtask ? subtask.id : null,
          team: recording.team || "",
          teamid: recording.teamid || "",
          numberOfRecordings: recording.numberOfRecordings || 0,
          targetValue: 0,
          reasons: recording.reasons || [],
          recordingName: recording.name || "",
          count: 1,
          recordings: [
            {
              recording_id: recording.recorderid,
              name: recording.name || null,
              reasons: recording.reasons || [],
            },
          ],
          groupedData: [
            {
              recording_id: recording.recorderid,
              recordingName: recording.name || null,
              reasons: recording.reasons || [],
              team: recording.team || "",
              teamid: recording.teamid || "",
              numberOfRecordings: recording.numberOfRecordings || 0,
              targetValue: 0,
              recordings: [
                {
                  recording_id: recording.recorderid,
                  name: recording.name || null,
                  reasons: recording.reasons || [],
                },
              ],
            },
          ],
        });
    });
    rowsOverview = rows;
    filteredRowsOverview = rowsOverview;
    if (expandedRowIds.length > 0)
      expandedRowIds = expandedRowIds.filter((id) =>
        filteredRowsOverview.some(
          (row) => row.id === id && row.groupedData.length > 1,
        ),
      );
  }

  function setRowData(row, recording) {
    return {
      reasons: recording.reasons || [],
      id: recording.recording_id,
      numberOfRecordings: recording.numberOfRecordings,
      process: row.process,
      processid: row.processid,
      recordingName: recording.recordingName,
      recordings: recording.recordings,
      subprocess: row.subprocess,
      subprocessid: row.subprocessid,
      subtask: row.subtask,
      subtaskid: row.subtaskid,
      targetValue: recording.targetValue,
      task: row.task,
      taskid: row.taskid,
      team: recording.team,
      teamid: recording.teamid,
    };
  }

  function setRows(
    selectedProcess,
    selectedSubprocess,
    selectedTeam,
    selectedTask,
    selectedSubtask,
    selectedAssignedOption,
    searchTerm,
  ) {
    filteredRowsOverview = rowsOverview.filter((row) => {
      const matchSubTask =
        !selectedSubtask ||
        selectedSubtask === "Subtask" ||
        row.subtaskid === selectedSubtask;
      const matchProcess =
        !selectedProcess ||
        selectedProcess === "Process" ||
        row.processid === selectedProcess;
      const matchSubprocess =
        !selectedSubprocess ||
        selectedSubprocess === "Subprocess" ||
        row.subprocessid === selectedSubprocess;
      const matchTeam =
        !selectedTeam ||
        selectedTeam === "Team" ||
        row.teamid === selectedTeam ||
        row.groupedData.some((data) => data.teamid === selectedTeam);
      const matchTask =
        !selectedTask || selectedTask === "Task" || row.taskid === selectedTask;

      const matchAssigned =
        !selectedAssignedOption ||
        selectedAssignedOption === "all" ||
        (selectedAssignedOption === "assigned" && row.process !== "") ||
        (selectedAssignedOption === "not_assigned" && row.process === "");
      return (
        matchSubTask &&
        matchProcess &&
        matchSubprocess &&
        matchTeam &&
        matchTask &&
        matchAssigned
      );
    });

    if (searchTerm) {
      filteredRowsOverview = filteredRowsOverview.filter((row) => {
        return matchSearchTerm(row, searchTerm);
      });
    }
    filteredRowIds = filteredRowsOverview.map((row) => row.id);
  }

  function matchSearchTerm(row, searchTerm) {
    if (!searchTerm) return true;
    const lowerSearchTerm = searchTerm.toLowerCase();
    return (
      row.process?.toLowerCase().includes(lowerSearchTerm) ||
      row.subprocess?.toLowerCase().includes(lowerSearchTerm) ||
      row.task?.toLowerCase().includes(lowerSearchTerm) ||
      row.subtask?.toLowerCase().includes(lowerSearchTerm) ||
      row.recordingName?.toLowerCase().includes(lowerSearchTerm) ||
      row.team?.toLowerCase().includes(lowerSearchTerm) ||
      row.groupedData?.some(
        (data) =>
          data?.recordingName?.toLowerCase().includes(lowerSearchTerm) ||
          data?.team?.toLowerCase().includes(lowerSearchTerm),
      )
    );
  }

  function getSubprocessDatalist(processId) {
    return listOfSubprocesses.filter((sp) => sp.process_id === processId);
  }

  function getTaskDatalist(subprocessId) {
    return listOfTasks.filter((t) => t.subprocess_id === subprocessId);
  }

  function getSubtaskDatalist(taskId) {
    return listOfSubTasks.filter((st) => st.task_id === taskId);
  }

  function removeAssignmentSelected() {
    removeAssignment(selectedRow.subtaskid, selectedRow.recordings);
    openDangerModal = false;
  }

  function exportSWEnvironemnt() {
    console.log("Exporting to Excel");
  }

  function handleEdit(row) {
    previewTaskid = row.subtaskid;
    selectedRow = row;
    editRow.taskid = row.taskid || "";
    editRow.subtaskid = row.subtaskid || "";
    editRow.subprocessid = row.subprocessid || "";
    editRow.processid = row.processid || "";
    editRow.recordings = row.recordings;
    openEditModal = true;
  }

  async function handleSave() {
    await removeAssignment(previewTaskid, editRow.recordings);
    const taskToUpdate = listOfSubTasks.find((t) => t.id === editRow.subtaskid);
    if (taskToUpdate) {
      const updatedRecordings = editRow.recordings.map((rec) => ({
        recording_id: rec.recording_id,
      }));
      const newRecordings = {
        recordings: [...taskToUpdate.recordings, ...updatedRecordings],
      };

      editTaskRecordings(taskToUpdate.id, newRecordings);
    } else {
      console.error("Subtask not found for editing:", editRow.subtaskid);
    }
    openEditModal = false;
  }

  async function removeAssignment(subtaskId, recordingToRemove) {
    if (!subtaskId) return;
    const recordings =
      listOfSubTasks.find((st) => st.id === subtaskId)?.recordings || [];
    const updatedRecordings = {
      recordings: recordings.filter(
        (r) =>
          !recordingToRemove.some((rr) => rr.recording_id === r.recording_id),
      ),
    };
    return editTaskRecordings(subtaskId, updatedRecordings);
  }

  async function deleteRecording() {
    if (deletingRecording || !selectedRow?.id) return;
    const recordingId = selectedRow.id;
    deletingRecording = true;

    try {
      const response = await fetchWithSession(
        `/api/damprojects/recordings/${recordingId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (!data.ok) return;

      listOfRecordings = listOfRecordings.filter(
        (row) => row.recorderid !== recordingId,
      );
      setRowsOverview();
      openDangerModal = false;
      recordingStore.getRecordings(idproject).catch((refreshError) => {
        console.error("Error refreshing recordings:", refreshError);
      });
    } catch (deleteError) {
      console.error("Error removing recording:", deleteError);
    } finally {
      deletingRecording = false;
    }
  }

  async function editTaskRecordings(subtaskId, newRecordings) {
    return fetchWithSession(`/api/damprojects/subtasks/${subtaskId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRecordings),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          let subtask = data.data;
          listOfSubTasks = listOfSubTasks.map((st) =>
            st.id === subtask.id
              ? { ...st, recordings: subtask.recordings }
              : st,
          );
          setRowsOverview();
        }
      })
      .catch((error) => {
        console.error("Error updating task:", error);
        throw (error = true);
      });
  }

  // The preview shows window titles from the traces. Until every entry of the L4 is
  // checked they can still contain clear text, so the preview stays locked per L4.
  // Open entries per L4 id, null while loading or when the counts could not be loaded.
  // "*" marks open entries without a known origin, they lock every preview.
  let openEntriesBySubtask = null;

  $: canPreview = (row) =>
    Boolean(row.subtaskid) &&
    openEntriesBySubtask !== null &&
    !openEntriesBySubtask["*"] &&
    !openEntriesBySubtask[String(row.subtaskid)];
  $: getPreviewLabel = (row) => {
    if (!row.subtaskid)
      return "Preview is only available after assigning this registration to a task and checking anonymization.";
    if (openEntriesBySubtask === null)
      return "Preview is not available yet, the anonymization status is loading.";
    if (openEntriesBySubtask["*"])
      return "Preview is only available after all entries are checked in the anonymization check.";
    if (openEntriesBySubtask[String(row.subtaskid)])
      return "Preview is only available after all entries of this subtask are checked in the anonymization check.";
    return "Preview registration";
  };

  function handleOpenPreview(row) {
    if (!canPreview(row)) return;
    selectedRow = row;
    currentSubtask = row.recordings[0].recording_id;
    openPreview = true;
  }

  onMount(async () => {
    loadingOverview = true;
    selectedTeam = "";
    try {
      // Mit idproject laden, sonst zeigen die Filter das ganze Unternehmens-Framework.
      await recordingStore.initialize(idproject);
      await recordingStore.getRecordings(idproject);
      setRowsOverview();
      // Stays locked if the counts cannot be loaded.
      fetchWithSession(
        `/api/damprojects/anonymization-open-entries-per-subtask?project_id=${idproject}`,
        { suppressErrorToast: true },
      )
        .then((response) => (response.ok ? response.json() : null))
        .then((counts) => (openEntriesBySubtask = counts))
        .catch(() => (openEntriesBySubtask = null));
    } catch (loadError) {
      error = true;
      errorMsg = "Registrierungen konnten nicht geladen werden.";
      console.error("Error loading registrations:", loadError);
    } finally {
      loadingOverview = false;
    }
  });
</script>

<Header
  section="Project Progress"
  area="Discovery"
  breadcrumb="Registration Overview"
  tooltipText="Review registered tasks and process details collected during task registration."
>
  <div data-guide="assign-overview-registrations">
    <Button
      text={assigningRegistrations
        ? "Assigning registrations…"
        : "Assign registrations"}
      kind="secondary"
      size="field"
      disabled={loadingOverview || !registrationsCount}
      on:click={openAssignmentModal}
    />
  </div>
  <!-- <Button
    text="Export to Excel"
    on:click={exportSWEnvironemnt}
    kind="secondary"
    disabled
  />
  <Button
    text="Import Process List"
    on:click={() => console.log("Importing Process List")}
    kind="secondary"
    disabled
  /> -->
  <!-- // TEMPORARILY COMMENTED OUT -->
  <!-- <PercentageBar
    total={totalTask}
    totalChecked={totalTaskRegistered}
    text="Tasks Registered"
  /> -->
</Header>

<Modal
  bind:open={assignmentModalOpen}
  modalHeading={assignmentFailed
    ? "Assignment failed"
    : assignmentComplete
      ? "Assignment complete"
      : "Assign registrations"}
  width={600}
  modalClass="assignment-modal-dialog"
  actions
  noSecondaryButton
  primaryButtonText={assigningRegistrations
    ? "Assigning…"
    : assignmentComplete
      ? "Done"
      : assignmentFailed
        ? "Try again"
        : "Assign"}
  primaryButtonVariant="secondary"
  primaryButtonNotAllow={assigningRegistrations}
  primaryButtonAction={assignmentComplete
    ? closeAssignmentModal
    : assignRegistrations}
  preventCloseOnClickOutside
  on:close={closeAssignmentModal}
>
  <div class="assignment-copy">
    {#if assignmentFailed}
      <p role="alert">{assignmentMessage}</p>
    {:else if assignmentComplete}
      <p role="status">{assignmentMessage}</p>
    {:else if !assigningRegistrations}
      <p>
        Assign unassigned registrations to the process framework? Existing
        assignments stay unchanged.
      </p>
    {/if}
    {#if assigningRegistrations}
      <div class="assignment-progress" role="status">
        <Loading small withOverlay={false} />
        <div>
          <strong>{assignmentMessage}</strong>
          {#if assignmentProgress}
            <span
              >{assignmentProgress.done} / {assignmentProgress.total} processed</span
            >
          {/if}
        </div>
      </div>
    {/if}
  </div>
  <div slot="left-buttons">
    {#if !assignmentComplete}
      <Button
        text={assigningRegistrations || assignmentFailed ? "Close" : "Cancel"}
        kind="outline-dark"
        on:click={closeAssignmentModal}
      />
    {/if}
  </div>
</Modal>

<SectionWrapper fullscreen={true} shrinkContent seamless seamlessPadding>
  <div slot="main" class="overview_canvas">
    <InfoBlock
      type="info"
      heading="Registration Overview"
      message="Review registered tasks and the process details collected during task registration. Use the filters to narrow the overview and the actions to preview, edit or remove registrations."
      showClose={true}
    />
    <div
      class="overview_topbar"
      style={loadingOverview ? "visibility: hidden;" : ""}
    >
      <!-- // TEMPORARILY COMMENTED OUT -->
      <!-- <Select
          items={selectOptions}
          placeholder="Show All"
          bind:selected={selectedOverviewIds}
          color="dark"
        /> -->
      <div class="filter_wrapper" data-guide="registration-overview-filters">
        <LFilters
          bind:this={lFiltersRef}
          {idproject}
          showAssignedFilter={true}
          {selectAssignedOptions}
          bind:selectedProcess
          bind:selectedSubprocess
          bind:selectedTask
          bind:selectedSubtask
          bind:selectedTeam
          bind:selectedAssignedOption
        />
      </div>
      <div class="overview_kpis" data-guide="registration-overview-kpis">
        <SideKPI
          name="Registrations"
          value={registrationsCount}
          loading={loadingOverview}
        />
        <SideKPI
          name="Last Registration"
          value={lastRegistrationDate}
          loading={loadingOverview}
        />
      </div>
    </div>
    <div
      class="table_wrapper process-registration-overview-table"
      data-guide="registration-overview-table"
    >
      {#if loadingOverview}
        <div class="custom-table keyword-table">
          <DataTableSkeleton
            rows={10}
            headers={headersOverview}
            showToolbar={true}
            showHeader={false}
          />
        </div>
      {:else}
        <!-- {#key filteredRowsOverview} -->
        <DataTableBlack
          headers={headersOverview}
          rows={filteredRowsOverview}
          sortable
          expandable
          batchExpansion
          sortKey="count"
          sortDirection="descending"
          searchValue={searchTerm}
          on:search={(e) => {
            searchTerm = e.detail.value;
          }}
          on:clearSearch={() => {
            searchTerm = "";
          }}
          slicePage
          bind:page={paginationOverview.page}
          bind:pageSize={paginationOverview.pageSize}
          pageSizes={[10, 25, 50, 75, 100]}
          showNewButton={false}
          totalItems={filteredRowsOverview.length}
          autoCountColumnStyle
          bind:expandedRowIds
          bind:selectedRowIds={selectedOverviewIds}
          nonExpandableRowIds={filteredRowsOverview
            .filter((row) => row.groupedData.length === 1)
            .map((row) => row.id)}
        >
          <svelte:fragment slot="cell-header" let:header>
            {#if header.key === "reasons"}
              <div class="header_with_tooltip">
                {header.value}
                <Tooltip>
                  <div>
                    <p style="margin: 0 0 0.5rem 0;">
                      The colour indicates possible outliers:
                    </p>
                    <div class="tooltip_legend_row">
                      <span class="cell_content duration_red"><Elipse /></span>
                      More than two indicators of possible outliers
                    </div>
                    <div class="tooltip_legend_row">
                      <span class="cell_content duration_yellow"
                        ><Elipse /></span
                      > One indicator of a possible outlier
                    </div>
                    <div class="tooltip_legend_row">
                      <span class="cell_content duration_green"><Elipse /></span
                      > No indicators of outliers
                    </div>
                  </div>
                </Tooltip>
              </div>
            {:else}
              {header.value}
            {/if}
          </svelte:fragment>
          <svelte:fragment slot="cell" let:row let:cell>
            {#if cell.key !== "recordingName" && cell.key !== "team" && cell.key !== "reasons" && cell.key !== "actions" && (cell.value === "" || cell.value === null)}
              <Tag
                type="high-contrast"
                size="sm"
                interactive
                class="assign_chip"
                on:click={() => handleEdit(row)}
              >
                + Assign {cell.key.charAt(0).toUpperCase() + cell.key.slice(1)}
              </Tag>
            {:else if cell.key === "reasons"}
              {#if cell.value && cell.value.length > 0}
                <div
                  class:cell_content={true}
                  class:duration_red={cell.value.length >= 2 ||
                    cell.value.includes("empty_recording")}
                  class:duration_yellow={cell.value.length === 1 &&
                    !cell.value.includes("empty_recording")}
                  class:duration_green={cell.value.length === 0}
                  title={cell.value.join(", ")}
                >
                  <Elipse></Elipse>
                </div>
              {/if}
            {:else if cell.key === "actions"}
              {#if row.groupedData.length === 1}
                <div class="actions-cell">
                  <Button
                    disabled={!canPreview(row)}
                    iconDescription={getPreviewLabel(row)}
                    aria-label={getPreviewLabel(row)}
                    icon={PREVIEW_ICON}
                    kind="secondary"
                    size="small"
                    on:click={() => handleOpenPreview(row)}
                  />
                  <Button
                    iconDescription="Edit registration"
                    aria-label="Edit registration"
                    on:click={() => handleEdit(row)}
                    icon={EDIT_ICON}
                    kind="secondary"
                    size="small"
                  />
                  <Button
                    class="edit-remove-btn"
                    iconDescription="Clear registration assignment"
                    aria-label="Clear registration assignment"
                    on:click={() => {
                      selectedRow = row;
                      modalTypeDelete = false;
                      openDangerModal = true;
                    }}
                    icon={ERASE_ICON}
                    size="small"
                  />
                  <Button
                    iconDescription="Delete registration"
                    aria-label="Delete registration"
                    on:click={() => {
                      selectedRow = row;
                      modalTypeDelete = true;
                      openDangerModal = true;
                    }}
                    kind="secondary"
                    icon={TRASH_ICON}
                    size="small"
                  />
                </div>
              {/if}
            {:else if cell.key === "edit"}
              {#if row.groupedData.length === 1}
                <Button
                  iconDescription="Edit registration"
                  aria-label="Edit registration"
                  on:click={() => handleEdit(row)}
                  icon={EDIT_ICON}
                  kind="secondary"
                  size="small"
                />
              {/if}
            {:else if cell.key === "preview"}
              {#if row.groupedData.length === 1}
                <Button
                  disabled={!canPreview(row)}
                  iconDescription={getPreviewLabel(row)}
                  aria-label={getPreviewLabel(row)}
                  on:click={() => handleOpenPreview(row)}
                  icon={PREVIEW_ICON}
                  kind="secondary"
                  size="small"
                />
              {/if}
            {:else if (cell.key === "clear") | (cell.key === "delete")}
              {#if row.groupedData.length === 1}
                <Button
                  iconDescription={cell.key === "clear"
                    ? "Clear registration assignment"
                    : "Delete registration"}
                  aria-label={cell.key === "clear"
                    ? "Clear registration assignment"
                    : "Delete registration"}
                  on:click={() => {
                    selectedRow = row;
                    modalTypeDelete = cell.key === "delete";
                    openDangerModal = true;
                  }}
                  icon={cell.key === "clear" ? ERASE_ICON : TRASH_ICON}
                  kind="secondary"
                  size="small"
                />
              {/if}
            {:else if cell.key === "count"}
              {#if cell.value > 1}
                <div class="cell_content count-cell">
                  {cell.value}
                </div>
              {/if}
            {:else if cell.key === "recordingName"}
              {#if row.groupedData.length === 1}
                <div
                  class="cell_content"
                  title={Array.isArray(cell.value)
                    ? cell.value.map((r) => r.name || r.recording_id).join(", ")
                    : cell.value}
                >
                  {cell.value}
                </div>
              {/if}
            {:else if cell.key === "team"}
              <div
                class="cell_content"
                title={[
                  ...new Set(row.groupedData.map((item) => item.team)),
                ].join(", ")}
                class:mask={cell.key === "mask"}
              >
                {[...new Set(row.groupedData.map((item) => item.team))].join(
                  ", ",
                )}
              </div>
            {:else if cell.key !== "team" || row.groupedData.length === 1}
              <div
                class="cell_content"
                title={cell.value}
                class:mask={cell.key === "mask"}
              >
                {cell.value}
              </div>
            {/if}
          </svelte:fragment>
          <svelte:fragment slot="expanded-row" let:row>
            <table class="expanded-table">
              <colgroup>
                <col style="width: 2rem" />
                {#each headersOverview as header}
                  <col style={`width: ${header.width || "auto"}`} />
                {/each}
              </colgroup>
              <tbody>
                {#each row.groupedData as recording}
                  {#if matchSearchTerm({ ...row, recordingName: recording.recordingName, team: recording.team, groupedData: [] }, searchTerm)}
                    <tr class="expanded-cell">
                      <td class="expansion-spacer" aria-hidden="true"></td>
                      {#each headersOverview as header}
                        <td
                          class:button-cell={header.key === "actions" ||
                            header.key === "edit" ||
                            header.key === "preview" ||
                            header.key === "clear" ||
                            header.key === "delete"}
                          class:time-cell={header.key === "duration"}
                          class:count_cell={header.key === "count"}
                        >
                          {#if header.key === "actions"}
                            <div class="actions-cell">
                              <Button
                                disabled={!canPreview(row)}
                                iconDescription={getPreviewLabel(row)}
                                aria-label={getPreviewLabel(row)}
                                on:click={() =>
                                  handleOpenPreview(setRowData(row, recording))}
                                icon={PREVIEW_ICON}
                                kind="secondary"
                                size="small"
                              />
                              <Button
                                iconDescription="Edit registration"
                                aria-label="Edit registration"
                                on:click={() =>
                                  handleEdit(setRowData(row, recording))}
                                icon={EDIT_ICON}
                                kind="secondary"
                                size="small"
                              />
                              <Button
                                iconDescription="Clear registration assignment"
                                aria-label="Clear registration assignment"
                                on:click={() => {
                                  selectedRow = setRowData(row, recording);
                                  modalTypeDelete = false;
                                  openDangerModal = true;
                                }}
                                icon={ERASE_ICON}
                                kind="secondary"
                                size="small"
                              />
                              <Button
                                iconDescription="Delete registration"
                                aria-label="Delete registration"
                                on:click={() => {
                                  selectedRow = setRowData(row, recording);
                                  modalTypeDelete = true;
                                  openDangerModal = true;
                                }}
                                icon={TRASH_ICON}
                                kind="secondary"
                                size="small"
                              />
                            </div>
                          {:else if header.key === "edit"}
                            <Button
                              iconDescription="Edit registration"
                              aria-label="Edit registration"
                              on:click={() =>
                                handleEdit(setRowData(row, recording))}
                              icon={EDIT_ICON}
                              kind="secondary"
                              size="small"
                            />
                          {:else if header.key === "preview"}
                            <Button
                              iconDescription={getPreviewLabel(row)}
                              aria-label={getPreviewLabel(row)}
                              disabled={!canPreview(row)}
                              on:click={() =>
                                handleOpenPreview(setRowData(row, recording))}
                              icon={PREVIEW_ICON}
                              kind="secondary"
                              size="small"
                            />
                          {:else if (header.key === "clear") | (header.key === "delete")}
                            <Button
                              iconDescription={header.key === "clear"
                                ? "Clear registration assignment"
                                : "Delete registration"}
                              aria-label={header.key === "clear"
                                ? "Clear registration assignment"
                                : "Delete registration"}
                              on:click={() => {
                                selectedRow = setRowData(row, recording);
                                modalTypeDelete = header.key === "delete";
                                openDangerModal = true;
                              }}
                              icon={header.key === "clear"
                                ? ERASE_ICON
                                : TRASH_ICON}
                              kind="secondary"
                              size="small"
                            />
                          {:else if header.key === "count"}
                            <div></div>
                          {:else if header.key === "reasons"}
                            {#if recording[header.key]}
                              <div
                                class:cell_content={true}
                                class:duration_red={recording[header.key]
                                  .length >= 2 ||
                                  recording[header.key].includes(
                                    "empty_recording",
                                  )}
                                class:duration_yellow={recording[header.key]
                                  .length === 1 &&
                                  !recording[header.key].includes(
                                    "empty_recording",
                                  )}
                                class:duration_green={recording[header.key]
                                  .length === 0}
                                title={recording[header.key].join(", ")}
                              >
                                <Elipse></Elipse>
                              </div>
                            {/if}
                          {:else if header.key === "team" || header.key === "recordingName"}
                            <div
                              class="cell_content"
                              title={recording[header.key]}
                              class:red-duration={header.key === "duration" &&
                                recording[header.key] < 10}
                            >
                              {recording[header.key]}
                            </div>
                          {:else}
                            <div class="cell_content" title={row[header.key]}>
                              {row[header.key]}
                            </div>
                          {/if}
                        </td>
                      {/each}
                    </tr>
                  {/if}
                {/each}
              </tbody>
            </table>
          </svelte:fragment>
        </DataTableBlack>
        <!-- {/key} -->
      {/if}
    </div>
  </div>
</SectionWrapper>

<SpotlightGuide
  bind:open={showOverviewGuide}
  bind:currentStep={overviewGuideStep}
  steps={overviewGuideSteps}
  allowInteraction={false}
/>

<Modal
  autowidth={true}
  preventCloseOnClickOutside
  bind:open={openEditModal}
  modalHeading="Edit Registered Process - Registration Name: {selectedRow?.recordingName}"
  actions
  width={653}
  primaryButtonText="Save"
  primaryButtonAction={handleSave}
>
  <div class="edit-select-field">
    <Select
      items={listOfProcesses
        .map((process) => ({ value: process.id, text: process.name }))
        .sort((a, b) => a.text.localeCompare(b.text))}
      placeholder="Select process"
      bind:selected={editRow.processid}
      onchange={() => {
        editRow.subprocessid = "";
        editRow.taskid = "";
        editRow.subtaskid = "";
      }}
      color="dark"
      labelText="Process (L1)"
    />
  </div>
  <div class="edit-select-field">
    <Select
      items={subprocessDatalist
        .map((subprocess) => ({
          value: subprocess.name,
          text: subprocess.name,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))}
      placeholder="Select subprocess"
      bind:selected={editRow.subprocess}
      onchange={() => {
        editRow.taskName = "";
        editRow.subtaskName = "";
      }}
      color="dark"
      labelText="Subprocess (L2)"
    />
  </div>
  <div class="edit-select-field">
    <Select
      items={taskDatalist
        .map((task) => ({ value: task.id, text: task.name }))
        .sort((a, b) => a.text.localeCompare(b.text))}
      placeholder="Select task"
      bind:selected={editRow.taskid}
      onchange={() => {
        editRow.subtaskid = "";
      }}
      color="dark"
      labelText="Task Name (L3)"
    />
  </div>
  <div class="edit-select-field">
    <Select
      labelText="Subtask Name (L4)"
      items={subtaskDatalist
        .map((subtask) => ({ value: subtask.name, text: subtask.name }))
        .sort((a, b) => a.text.localeCompare(b.text))}
      placeholder="Select subtask"
      bind:selected={editRow.subtaskName}
      color="dark"
    />
  </div>
</Modal>

<DangerModal
  danger
  preventCloseOnClickOutside
  bind:open={openDangerModal}
  modalHeading="{modalTypeDelete
    ? 'Remove Registered Process'
    : 'Remove registration Assignment'} - Registration Name: {selectedRow?.recordingName}"
  primaryButtonText={deletingRecording
    ? "Removing..."
    : modalTypeDelete
      ? "Remove Recording"
      : "Remove Assignment"}
  primaryButtonDisabled={deletingRecording}
  secondaryButtonText="Cancel"
  on:click:button--primary={modalTypeDelete
    ? deleteRecording
    : removeAssignmentSelected}
  on:click:button--secondary={() => {
    if (!deletingRecording) openDangerModal = false;
  }}
>
  <div class="deleteModalBody">
    <p>
      This action removes {!modalTypeDelete ? "the assignment of " : ""}this
      registration:
      <span class="project-name">{selectedRow?.recordings[0].name}</span>
      {#if selectedRow?.task}
        from the task <span class="project-name">{selectedRow?.task}</span>
      {/if}
    </p>
    <p><span class="orange">This cannot be undone.</span></p>
    {#if deletingRecording}
      <InlineLoading
        status="active"
        description="Removing recording. Please wait..."
      />
    {/if}
    {#if !modalTypeDelete}
      <p>
        <span
          >The registration must be assigned again before you or others can
          access it.</span
        >
      </p>
    {/if}
  </div>
</DangerModal>

<Dialog
  preventCloseOnClickOutside
  bind:open={openPreview}
  width={1200}
  height={1200}
  {fullscreen}
  on:close={() => {
    taskExplorerPreviewController.abort();
  }}
>
  <svelte:fragment slot="heading">
    <h3 class="dialog-heading">
      Preview Task Registration - {selectedRow?.recordingName}
    </h3>
  </svelte:fragment>
  <div class="info-wrapper">
    <ul>
      <li><strong>L1:</strong> {selectedRow.process}</li>
      <li><strong>L2:</strong> {selectedRow.subprocess}</li>
      <li><strong>L3:</strong> {selectedRow.task}</li>
      <li><strong>L4:</strong> {selectedRow.subtask}</li>
    </ul>
  </div>
  <TaskExplorerPreview
    currentTask={currentSubtask}
    bind:fullscreen
    bind:controller={taskExplorerPreviewController}
    bind:graphActivities
  />
</Dialog>

<style>
  :global(.assignment-modal-dialog .bx--modal-container) {
    width: min(40rem, calc(100vw - 2rem)) !important;
    max-width: 40rem !important;
  }

  :global(.assignment-modal-dialog .modal_wrapper) {
    width: 100% !important;
    box-sizing: border-box;
  }

  :global(.assignment-modal-dialog .bx--modal-content) {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .assignment-copy {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .assignment-copy p {
    margin: 0;
    line-height: 1.5;
  }

  .assignment-progress {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    margin: 0;
    background: var(--pax-smoke, #f7f8fa);
    border-radius: var(--br);
  }

  .assignment-progress strong,
  .assignment-progress span {
    display: block;
  }

  .assignment-progress > div {
    min-width: 0;
  }

  .assignment-progress span {
    margin-top: 0.25rem;
    font-size: 0.875rem;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    min-width: 0;
    overflow-x: clip;
  }

  :global(.process-registration-overview-table .bx--data-table-container) {
    min-width: 0;
    width: 100%;
    /* clip instead of hidden: hidden turns overflow-y into auto, so a 1px rounding
       difference in the expanded rows showed a vertical scrollbar. */
    overflow-x: clip;
  }

  :global(.process-registration-overview-table .bx--data-table) {
    width: 100%;
    min-width: 0;
    table-layout: fixed;
  }

  :global(.process-registration-overview-table .bx--data-table th),
  :global(.process-registration-overview-table .bx--data-table td) {
    min-width: 0;
    overflow: hidden;
  }

  .overview_canvas {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
    width: 100%;
    min-width: 0;
  }

  .overview_canvas :global(.warning-notice) {
    margin-bottom: 0;
  }

  .overview_topbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
  }

  .overview_kpis {
    display: grid;
    grid-template-columns: repeat(2, minmax(11rem, 1fr));
    gap: 0.5rem;
    min-width: 23rem;
  }

  .cell_content {
    color: var(--pax-black, #1c1c20);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 0.75rem */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .count-cell {
    overflow: visible;
  }

  .mask {
    text-align: center;
  }
  /*
  .status {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header_group {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 0.31rem;
  } */

  /*
  .select_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.25rem;
    margin-bottom: 0.62rem;
  }

  .select_showAll {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.81rem;
    max-width: fit-content;
    margin-bottom: 0.62rem;
  } */

  .filter_wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.38rem;
    min-width: 0;
  }

  .filter_wrapper :global(.filter_field) {
    width: 10.5rem;
    min-width: 0;
  }

  .filter_wrapper :global(.filter_field .custom_select),
  .filter_wrapper :global(.filter_field .bx--form-item),
  .filter_wrapper :global(.filter_field .bx--select-input),
  .filter_wrapper :global(.filter_field .bx--select-input__wrapper) {
    width: 100%;
  }


  .edit-select-field {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-cell {
    display: flex;
    gap: 0.25rem;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  :global(.bx--tag.assign_chip) {
    max-width: 100%;
    margin: 0;
    background-color: var(--pax-black);
    color: white;
  }

  :global(.bx--tag.assign_chip:hover) {
    opacity: 0.8;
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--secondary) {
    background-color: var(--pax-black);
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--primary) {
    background-color: var(--pax-orange, #393939);
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--primary):hover {
    background-color: var(--pax-orange-opacity);
  }

  .deleteModalBody .project-name {
    font-weight: bold;
  }

  .deleteModalBody {
    padding-top: 1.5rem;
    display: flex;
    gap: 1.5rem;
    flex-direction: column;
  }

  .orange {
    font-weight: bold;
    color: var(--pax-orange);
  }

  .info-wrapper,
  .info-wrapper ul {
    display: flex;
    flex-direction: column;
  }
  .info-wrapper {
    gap: 1rem;
    position: absolute;
    top: 4.1rem;
    left: 0.5rem;
    z-index: 10;
    background: white;
    border-radius: 1rem;
    padding: 1rem;
  }
  .info-wrapper ul {
    gap: 0.3rem;
  }

  .info-wrapper strong {
    font-weight: 600;
  }

  /* .recording-duration {
    position: relative;
    left: calc(100% - 348px);
    font-size: 0.75rem;
    font-style: normal;
    text-overflow: ellipsis;
    max-width: 15rem;
  } */

  .red-duration {
    color: red;
  }

  :global(
      .process-registration-overview-table
        tr.bx--parent-row.bx--expandable-row
        + tr[data-child-row]
        > td
    ) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  :global(
      .process-registration-overview-table
        tr.bx--parent-row.bx--expandable-row
        + tr[data-child-row]
        .bx--child-row-inner-container
    ) {
    width: 100%;
  }

  /* :global(
      .table_wrapper .custom-table
        tr.bx--parent-row.bx--expandable-row
        + tr[data-child-row]
        td
    ) {
    padding-left: 1.6rem;
    padding-right: 0.5rem;
    background-color: var(--pax-smoke) !important;
  } */

  .expanded-table td {
    min-width: 0;
    overflow: hidden;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  /* :global(.table_wrapper .custom-table .bx--expandable-row > td) {
    box-shadow:
      inset 1px 0 0 0 white,
      inset -1px 0 0 0 white !important;
  } */

  .expanded-cell,
  .expanded-table {
    table-layout: fixed;
    width: 100%;
  }

  .expanded-table {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    table-layout: fixed !important;
  }

  :global(.process-registration-overview-table th.bx--table-expand) {
    width: 2rem;
  }

  .expanded-table td.expansion-spacer {
    padding: 0 !important;
  }

  td.button-cell {
    width: 70px;
  }
  td.time-cell {
    width: 100px;
  }

  td.count_cell {
    width: 30px;
  }
  /* 
  :global(.table_wrapper .custom-table th .bx--table-header-label) {
    padding-right: 0 !important;
    padding-left: 0 !important;
    text-align: center;
  }

  :global(.custom-table thead th svg path) {
    fill: var(--pax-white);
  } */

  .duration_red {
    text-align: center;
    color: #f08e90;
  }

  .duration_yellow {
    text-align: center;
    color: #e9f08e;
  }

  .duration_green {
    text-align: center;
    color: #8ef095;
  }

  /* .duration_blue {
    text-align: center;
    color: #7eb8f0;
  } */

  .tooltip_legend_row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .dialog-heading {
    display: flex;
    margin: 0;
    padding: 0;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: 0.01rem;
    color: #161616;
    flex: 1;
    padding-right: 2rem;
  }

  .dialog-heading span {
    display: flex;
    align-items: center;
  }

  /* :global(
      .table_wrapper .custom-table
        .bx--data-table
        thead
        th.bx--table-expand
    ) {
    width: 1.5rem;
  }

  :global(
      .table_wrapper .custom-table .bx--data-table td.bx--table-expand
    ),
  :global(
      .table_wrapper .custom-table .bx--data-table th.bx--table-expand
    ) {
    padding: 0;
  } */

  :global(.custom-table .bx--skeleton th) {
    background-color: var(--pax-black) !important;
    color: white !important;
    fill: white;
  }

  /* 
  bx--skeleton bx--data-table bx--data-table--short
   */
</style>
